import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../services/api';

// Add CSS for hover effects and animations
const injectStyles = () => {
  const styleId = 'admin-panel-styles';
  if (document.getElementById(styleId)) return;
  
  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateY(-10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    [data-hover-list-item]:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0,0,0,0.1) !important;
      border-color: #10b981 !important;
    }
    
    [data-hover-card]:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 25px rgba(0,0,0,0.1) !important;
    }
    
    [data-hover-btn]:hover:not(:disabled) {
      transform: translateY(-2px);
      filter: brightness(1.1);
    }
    
    [data-hover-btn]:active:not(:disabled) {
      transform: translateY(0) scale(0.98);
    }
    
    [data-admin-input]:focus {
      border-color: #10b981 !important;
      box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1) !important;
      outline: none;
    }
    
    [data-login-input]:focus {
      border-color: #10b981 !important;
      box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.15) !important;
    }
    
    /* Mobile responsive styles for Admin Panel */
    @media (max-width: 768px) {
      [data-admin-container] {
        padding: 10px !important;
      }
      [data-admin-card] {
        padding: 16px !important;
        border-radius: 12px !important;
      }
      [data-admin-topbar] {
        padding: 12px 16px !important;
        flex-direction: column !important;
        gap: 12px !important;
      }
      [data-admin-tabs] {
        flex-wrap: wrap !important;
        gap: 6px !important;
      }
      [data-admin-tab] {
        padding: 8px 12px !important;
        font-size: 12px !important;
      }
      [data-admin-content] {
        padding: 16px !important;
      }
      [data-admin-list-item] {
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 12px !important;
      }
      [data-admin-list-actions] {
        flex-wrap: wrap !important;
        justify-content: flex-start !important;
      }
      [data-admin-form-row] {
        flex-direction: column !important;
      }
      [data-admin-table] {
        font-size: 12px !important;
      }
      [data-admin-table] th,
      [data-admin-table] td {
        padding: 8px 6px !important;
      }
      [data-admin-modal] {
        width: 95% !important;
        max-width: none !important;
        margin: 10px !important;
        padding: 20px !important;
      }
      [data-admin-btn] {
        padding: 10px 16px !important;
        font-size: 13px !important;
      }
      /* Settings section mobile styles */
      [data-settings-row] {
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 12px !important;
      }
      [data-settings-input] {
        width: 100% !important;
        max-width: none !important;
      }
      [data-settings-option] {
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 10px !important;
      }
      [data-settings-option-actions] {
        justify-content: flex-start !important;
      }
      [data-settings-card] {
        padding: 16px !important;
      }
      [data-settings-title] {
        font-size: 16px !important;
      }
      [data-settings-desc] {
        font-size: 13px !important;
      }
      /* BFI Questions tab mobile styles */
      [data-bfi-header] {
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 12px !important;
      }
      [data-bfi-actions] {
        flex-direction: column !important;
        gap: 8px !important;
      }
      [data-bfi-actions] button,
      [data-bfi-actions] label {
        width: 100% !important;
        justify-content: center !important;
        font-size: 13px !important;
        padding: 10px 12px !important;
      }
      [data-bfi-lang-row] {
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 8px !important;
      }
      [data-bfi-lang-row] select {
        width: 100% !important;
      }
      [data-bfi-table-container] {
        margin: 0 -16px;
        padding: 0 8px;
      }
      [data-bfi-table] {
        font-size: 11px !important;
        min-width: 800px;
      }
      [data-bfi-table] th,
      [data-bfi-table] td {
        padding: 6px 4px !important;
      }
      /* Rooms grid mobile styles */
      [data-rooms-grid] {
        grid-template-columns: 1fr !important;
        gap: 20px !important;
      }
      [data-room-card] {
        padding: 14px !important;
      }
      /* Tasks/Topics editor mobile styles */
      [data-editor-form] {
        flex-direction: column !important;
        gap: 12px !important;
      }
      [data-editor-form] input,
      [data-editor-form] textarea {
        width: 100% !important;
      }
      [data-editor-actions] {
        flex-direction: column !important;
        gap: 8px !important;
      }
      [data-editor-actions] button {
        width: 100% !important;
      }
      /* Settings text fields grid mobile */
      [data-settings-grid] {
        grid-template-columns: 1fr !important;
      }
      [data-settings-grid] input,
      [data-settings-grid] textarea {
        width: 100% !important;
        box-sizing: border-box !important;
      }
      /* BFI edit row mobile */
      [data-bfi-edit-row] {
        grid-template-columns: 1fr !important;
      }
      [data-bfi-edit-row] textarea,
      [data-bfi-edit-row] input,
      [data-bfi-edit-row] select {
        width: 100% !important;
        box-sizing: border-box !important;
      }
    }
  `;
  document.head.appendChild(style);
};

const AdminPanel = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    injectStyles();
    
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const [adminUser, setAdminUser] = useState('admin');
  const [adminPass, setAdminPass] = useState('');
  const [token, setToken] = useState(localStorage.getItem('adminToken') || '');
  const [loginError, setLoginError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);
  const [tab, setTab] = useState('overview');
  const [users, setUsers] = useState([]);
  const [expandedUserId, setExpandedUserId] = useState(null);
  const [rooms, setRooms] = useState([]);
  const [expandedReasonRoomId, setExpandedReasonRoomId] = useState(null);
  const [roomMessages, setRoomMessages] = useState([]);
  const [selectedRoomId, setSelectedRoomId] = useState(null);
  // Overview dashboard data (computed client-side from /admin/users + /admin/rooms)
  const [overview, setOverview] = useState(null);

  const authed = !!token;

  const getAuthHeader = () => {
    const currentToken = localStorage.getItem('adminToken') || token;
    return currentToken ? { Authorization: `Bearer ${currentToken}` } : {};
  };

  const login = async (e) => {
    e.preventDefault();
    const username = adminUser.trim();
    if (!username || !adminPass) {
      setLoginError('Enter the admin ID and password.');
      return;
    }

    const t = `${username}:${adminPass}`;
    setLoginLoading(true);
    setLoginError('');
    try {
      await axios.post(`${API_BASE_URL}/admin/login`, {}, {
        headers: { Authorization: `Bearer ${t}` }
      });
      localStorage.setItem('adminToken', t);
      setToken(t);
      setTab('overview');
      setAdminPass('');
    } catch (error) {
      localStorage.removeItem('adminToken');
      setToken('');
      setLoginError(error.response?.data?.detail || 'Unable to sign in. Please check the admin credentials.');
    } finally {
      setLoginLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setToken('');
    setTab('overview');
    setAdminUser('admin');
    setAdminPass('');
    setLoginError('');
    setUsers([]);
    setExpandedUserId(null);
    setRooms([]);
    setRoomMessages([]);
  };

  const loadUsers = async () => {
    const res = await axios.get(`${API_BASE_URL}/admin/users`, { headers: getAuthHeader() });
    setUsers(res.data || []);
  };
  const setUserType = async (userId, userType) => {
    try {
      const res = await axios.put(
        `${API_BASE_URL}/admin/users/${userId}/type`,
        { user_type: userType || null },
        { headers: getAuthHeader() }
      );
      // Update the single row in place to keep the panel expanded.
      setUsers(prev => prev.map(u => (u.id === userId ? { ...u, user_type: res.data?.user_type ?? null } : u)));
    } catch (err) {
      alert(`Failed to update role: ${err.response?.data?.detail || err.message}`);
    }
  };
  // Cultural Turing Test: set a Pretender's ground-truth identity (+ claimed culture).
  const setPretenderIdentity = async (userId, identity) => {
    try {
      const res = await axios.put(
        `${API_BASE_URL}/admin/users/${userId}/identity`,
        { pretender_identity: identity || null, claimed_culture: 'german' },
        { headers: getAuthHeader() }
      );
      setUsers(prev => prev.map(u => (u.id === userId ? {
        ...u,
        pretender_identity: res.data?.pretender_identity ?? null,
        claimed_culture: res.data?.claimed_culture ?? null
      } : u)));
    } catch (err) {
      alert(`Failed to update identity: ${err.response?.data?.detail || err.message}`);
    }
  };
  const loadRooms = async () => {
    const res = await axios.get(`${API_BASE_URL}/admin/rooms`, { headers: getAuthHeader() });
    setRooms(res.data || []);
  };
  const loadMessages = async (roomId) => {
    setSelectedRoomId(roomId);
    const res = await axios.get(`${API_BASE_URL}/admin/messages/${roomId}`, { headers: getAuthHeader() });
    // Handle new format: res.data is now an object with messages array
    const messagesData = res.data?.messages || res.data || [];
    setRoomMessages(messagesData);
  };
  // Overview dashboard: pull users + rooms and compute study-level stats client-side.
  const loadOverview = async () => {
    try {
      const [uRes, rRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/admin/users`, { headers: getAuthHeader() }),
        axios.get(`${API_BASE_URL}/admin/rooms`, { headers: getAuthHeader() }),
      ]);
      const allUsers = uRes.data || [];
      const allRooms = rRes.data || [];

      const guessers = allUsers.filter(u => u.user_type === 'guesser');
      const pretenders = allUsers.filter(u => u.user_type === 'pretender');
      const guessersOnline = guessers.filter(u => u.is_online).length;
      const pretendersOnline = pretenders.filter(u => u.is_online).length;
      const unassigned = allUsers.filter(u => !u.user_type).length;
      const pretendersMissingIdentity = pretenders.filter(u => !u.pretender_identity).length;

      const totalGames = allRooms.length;
      const withVerdict = allRooms.filter(r => r.guesser_guess != null);
      // Scored games: only rooms where ground truth was set (guess_correct is a real boolean).
      const scored = allRooms.filter(r => r.guess_correct === true || r.guess_correct === false);
      const correct = scored.filter(r => r.guess_correct === true).length;
      const guesserAccuracy = scored.length > 0 ? Math.round((correct / scored.length) * 100) : null;
      const pretenderWinRate = scored.length > 0 ? Math.round(((scored.length - correct) / scored.length) * 100) : null;

      const questionCounts = withVerdict
        .map(r => (typeof r.guesser_questions === 'number' ? r.guesser_questions : null))
        .filter(n => n != null);
      const avgQuestions = questionCounts.length > 0
        ? (questionCounts.reduce((a, b) => a + b, 0) / questionCounts.length).toFixed(1)
        : null;

      setOverview({
        totalUsers: allUsers.length,
        guessers: guessers.length,
        pretenders: pretenders.length,
        guessersOnline,
        pretendersOnline,
        unassigned,
        pretendersMissingIdentity,
        totalGames,
        gamesWithVerdict: withVerdict.length,
        scoredGames: scored.length,
        guesserAccuracy,
        pretenderWinRate,
        avgQuestions,
      });
    } catch (e) {
      console.error('Failed to load overview:', e);
      if (e.response?.status === 401) {
        localStorage.removeItem('adminToken');
        setToken('');
        setLoginError('Your admin session was invalid. Please sign in again.');
      }
      setOverview(null);
    }
  };

  // Force every currently-online user offline and drop their session.
  const logoutAllUsers = async () => {
    if (!window.confirm('Log out ALL currently-online users? They will be returned to the login screen. Accounts and study data are kept.')) return;
    try {
      const res = await axios.post(`${API_BASE_URL}/admin/logout-all`, {}, { headers: getAuthHeader() });
      alert(`✅ Logged out ${res.data?.logged_out ?? 0} online user(s).`);
      if (tab === 'users') loadUsers();
      if (tab === 'overview') loadOverview();
    } catch (err) {
      alert(`Failed to log out users: ${err.response?.data?.detail || err.message}`);
    }
  };

  // Delete a single chat room (messages + memberships + room-scoped answers).
  const deleteRoom = async (roomId) => {
    if (!window.confirm(`Delete chat #${roomId} and all of its messages? This cannot be undone.`)) return;
    try {
      await axios.delete(`${API_BASE_URL}/admin/room/${roomId}`, { headers: getAuthHeader() });
      if (selectedRoomId === roomId) { setSelectedRoomId(null); setRoomMessages([]); }
      loadRooms();
    } catch (err) {
      alert(`Failed to delete chat: ${err.response?.data?.detail || err.message}`);
    }
  };

  // Permanently delete a single user account and their data.
  const deleteUser = async (u) => {
    const label = u?.full_name ? `${u.full_name} (@${u.username})` : `user #${u?.id}`;
    if (!window.confirm(`Permanently delete ${label}? Their messages, memberships and answers are removed too. This cannot be undone.`)) return;
    try {
      await axios.delete(`${API_BASE_URL}/admin/users/${u.id}`, { headers: getAuthHeader() });
      setUsers(prev => prev.filter(x => x.id !== u.id));
      if (expandedUserId === u.id) setExpandedUserId(null);
    } catch (err) {
      alert(`Failed to delete user: ${err.response?.data?.detail || err.message}`);
    }
  };

  // Delete every chat room (keeps user accounts).
  const deleteAllRooms = async () => {
    if (!window.confirm('Delete ALL chats (every room and its messages)? User accounts are kept. This cannot be undone.')) return;
    try {
      const res = await axios.post(`${API_BASE_URL}/admin/rooms/delete-all`, {}, { headers: getAuthHeader() });
      alert(`✅ Deleted ${res.data?.deleted_rooms ?? 0} chat(s).`);
      setSelectedRoomId(null);
      setRoomMessages([]);
      loadRooms();
      if (tab === 'overview') loadOverview();
    } catch (err) {
      alert(`Failed to delete chats: ${err.response?.data?.detail || err.message}`);
    }
  };

  // Legacy questions CRUD removed in favor of BFI editor
  // Removed: per-user answers view

  const downloadJSON = (filename, data) => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  const downloadAnswersForUserInRoom = async (roomId, userId) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/admin/room/${roomId}/answers`, { headers: getAuthHeader() });
      const answers = res.data || [];
      const filtered = answers.filter(a => (a.answered_by?.id === userId));
      downloadJSON(`room_${roomId}_answers_user_${userId}.json`, filtered);
    } catch (e) {
      // ignore download errors in UI; could surface toast if needed
    }
  };

  const exportAll = async () => {
    const res = await axios.get(`${API_BASE_URL}/admin/export/all`, { headers: getAuthHeader() });
    downloadJSON('export_all.json', res.data);
  };

  const exportUser = async (userId) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/admin/export/user/${userId}`, { headers: getAuthHeader() });
      downloadJSON(`user_${userId}.json`, res.data);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 404) {
        alert('User not found. They may have been deleted.');
      } else if (status === 401) {
        alert('Admin session expired. Please log in again.');
        logout();
      } else {
        alert('Failed to export user. Please try again.');
      }
    }
  };

  const exportRoom = async (roomId) => {
    const res = await axios.get(`${API_BASE_URL}/admin/export/room/${roomId}`, { headers: getAuthHeader() });
    downloadJSON(`room_${roomId}.json`, res.data);
  };

  // Download chat with user_a/user_b labels (uses export endpoint)
  const downloadRoomMessages = async (roomId) => {
    const res = await axios.get(`${API_BASE_URL}/admin/export/room/${roomId}/messages`, { headers: getAuthHeader() });
    downloadJSON(`room_${roomId}_messages.json`, res.data || {});
  };

  const exportAllRooms = async () => {
    const res = await axios.get(`${API_BASE_URL}/admin/export/rooms/messages`, { headers: getAuthHeader() });
    downloadJSON('rooms_messages_all.json', res.data || []);
  };

  const exportAllUsers = async () => {
    const res = await axios.get(`${API_BASE_URL}/admin/users`, { headers: getAuthHeader() });
    downloadJSON('users_all.json', res.data || []);
  };

  // Settings state
  const [settingsDraft, setSettingsDraft] = useState({});
  const loadSettings = async () => {
    const res = await axios.get(`${API_BASE_URL}/settings`, { headers: getAuthHeader() });
    const s = res.data?.settings || {};
    setSettingsDraft(s);
  };
  const saveOneSetting = async (key) => {
    const value = settingsDraft[key] || '';
    await axios.post(`${API_BASE_URL}/admin/settings`, { settings: { [key]: value } }, { headers: getAuthHeader() });
    await loadSettings();
  };
  const saveCompletionCode = async () => {
    const code = String(settingsDraft['study.completion_code'] || '');
    if (!code.trim()) {
      alert('Completion code cannot be empty.');
      return;
    }
    try {
      await axios.post(
        `${API_BASE_URL}/admin/settings`,
        { settings: { 'study.completion_code': code } },
        { headers: getAuthHeader() }
      );
      await loadSettings();
      alert('✅ Completion code saved.');
    } catch (err) {
      alert(`Failed to save completion code: ${err.response?.data?.detail || err.message}`);
    }
  };

  useEffect(() => {
    if (!authed) return;
    if (tab === 'overview') loadOverview();
    if (tab === 'users') loadUsers();
    if (tab === 'rooms_messages') loadRooms();
    if (tab === 'settings') loadSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, authed]);

  // Clear room-scoped data when leaving the Messages tab; do not auto-load any room
  useEffect(() => {
    if (!authed) return;
    if (tab !== 'rooms_messages') {
      setRoomMessages([]);
    }
    if (tab === 'rooms_messages') {
      setSelectedRoomId(null);
      setRoomMessages([]);
      // refresh rooms each time this tab is focused
      loadRooms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, authed]);

  // Small stat tile used by the Overview dashboard.
  const statCard = (label, value, icon, valueColor) => (
    <div style={styles.statCard}>
      <div style={{ fontSize: 22, marginBottom: 8 }}>{icon}</div>
      <div style={{ fontSize: 28, fontWeight: 800, color: valueColor || '#111827', lineHeight: 1.1 }}>{value}</div>
      <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4, fontWeight: 600 }}>{label}</div>
    </div>
  );

  if (!authed) {
    return (
      <div style={styles.container}>
        <div style={styles.loginCard}>
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            <h2 style={styles.loginTitle}>Admin Sign In</h2>
            <p style={styles.loginSubtitle}>Access administrative tools and settings</p>
          </div>
          <form onSubmit={login} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <input aria-label="Admin ID" placeholder="Admin ID" value={adminUser} onChange={(e) => setAdminUser(e.target.value)} style={styles.loginInput} data-login-input />
            <input aria-label="Admin password" placeholder="Password" type="password" value={adminPass} onChange={(e) => setAdminPass(e.target.value)} style={styles.loginInput} data-login-input />
            {loginError && (
              <div role="alert" style={{ padding: 10, borderRadius: 8, background: '#fef2f2', color: '#b91c1c', fontSize: 13 }}>
                {loginError}
              </div>
            )}
            <button type="submit" disabled={loginLoading} style={{ ...styles.loginButton, opacity: loginLoading ? 0.7 : 1 }} data-hover-btn>
              {loginLoading ? 'Signing in…' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.page} data-admin-container>
      <div style={styles.topbar} data-admin-topbar>
        <div style={styles.topbarBrand}>
          <div style={styles.brandIcon}>⚡</div>
          <div style={styles.brandText}>Admin Panel</div>
        </div>
        <div style={styles.tabsContainer} data-admin-tabs>
          <button onClick={() => setTab('overview')} style={{ ...styles.tabBtn, ...(tab === 'overview' ? styles.tabActive : {}) }} data-admin-tab>
            <span style={styles.tabIcon}>📊</span>
            <span>Overview</span>
          </button>
          <button onClick={() => setTab('users')} style={{ ...styles.tabBtn, ...(tab === 'users' ? styles.tabActive : {}) }} data-admin-tab>
            <span style={styles.tabIcon}>👥</span>
            <span>Users</span>
          </button>
          <button onClick={() => setTab('rooms_messages')} style={{ ...styles.tabBtn, ...(tab === 'rooms_messages' ? styles.tabActive : {}) }} data-admin-tab>
            <span style={styles.tabIcon}>💬</span>
            <span>Messages</span>
          </button>
          <button onClick={() => setTab('settings')} style={{ ...styles.tabBtn, ...(tab === 'settings' ? styles.tabActive : {}) }} data-admin-tab>
            <span style={styles.tabIcon}>⚙️</span>
            <span>Settings</span>
          </button>
        </div>
        <button onClick={logout} style={styles.logoutBtn}>
          <span style={{ marginRight: 6 }}>🚪</span>
          Logout
        </button>
      </div>

      <div style={styles.content}>
        {tab === 'overview' && (
          <div>
            <div style={styles.sectionHeader}>
              <div style={styles.sectionTitle}>
                <span style={styles.sectionIcon}>📊</span>
                <h3 style={styles.sectionHeading}>Study Overview</h3>
              </div>
              <button onClick={loadOverview} style={styles.downloadBtn} data-hover-btn>
                <span style={{ marginRight: 6 }}>🔄</span>
                Refresh
              </button>
            </div>

            {!overview ? (
              <div style={{ color: '#6b7280' }}>Loading overview…</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                <div>
                  <h4 style={{ margin: '0 0 12px 0', fontSize: 15, fontWeight: 700, color: '#374151' }}>Participants</h4>
                  <div style={styles.statGrid}>
                    {statCard('Guessers online', `${overview.guessersOnline} / ${overview.guessers}`, '🕵️')}
                    {statCard('Pretenders online', `${overview.pretendersOnline} / ${overview.pretenders}`, '🎭')}
                    {statCard('Total users', overview.totalUsers, '👥')}
                    {statCard('No role assigned', overview.unassigned, '❔', overview.unassigned > 0 ? '#b45309' : undefined)}
                  </div>
                </div>

                <div>
                  <h4 style={{ margin: '0 0 12px 0', fontSize: 15, fontWeight: 700, color: '#374151' }}>Games</h4>
                  <div style={styles.statGrid}>
                    {statCard('Total games', overview.totalGames, '💬')}
                    {statCard('With a verdict', overview.gamesWithVerdict, '✅')}
                    {statCard('Scored games', overview.scoredGames, '🎯')}
                    {statCard('Avg. questions / game', overview.avgQuestions ?? '—', '❓')}
                  </div>
                </div>

                <div>
                  <h4 style={{ margin: '0 0 12px 0', fontSize: 15, fontWeight: 700, color: '#374151' }}>Outcomes</h4>
                  <div style={styles.statGrid}>
                    {statCard('Guesser accuracy', overview.guesserAccuracy == null ? '—' : `${overview.guesserAccuracy}%`, '🎯')}
                    {statCard('Pretender win rate', overview.pretenderWinRate == null ? '—' : `${overview.pretenderWinRate}%`, '🏆')}
                  </div>
                  <div style={{ marginTop: 10, fontSize: 12, color: '#9ca3af' }}>
                    Accuracy is computed only over games where the Pretender's ground-truth identity was set
                    ({overview.scoredGames} of {overview.totalGames}).
                  </div>
                </div>

                {overview.pretendersMissingIdentity > 0 && (
                  <div style={{ padding: 16, borderRadius: 12, background: '#fffbeb', border: '1px solid #fcd34d', color: '#92400e', fontSize: 14 }}>
                    ⚠️ {overview.pretendersMissingIdentity} Pretender{overview.pretendersMissingIdentity === 1 ? '' : 's'} {overview.pretendersMissingIdentity === 1 ? 'has' : 'have'} no ground-truth identity set.
                    Their games can't be scored — set it in the <strong>Users</strong> tab.
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {tab === 'users' && (
          <div>
            <div style={styles.sectionHeader}>
              <div style={styles.sectionTitle}>
                <span style={styles.sectionIcon}>👥</span>
                <h3 style={styles.sectionHeading}>Users</h3>
              </div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <button onClick={logoutAllUsers} style={styles.dangerBtn} data-hover-btn>
                  <span style={{ marginRight: 6 }}>🚪</span>
                  Log Out Online Users
                </button>
                <button onClick={exportAllUsers} style={styles.downloadBtn}>
                  <span style={{ marginRight: 6 }}>📥</span>
                  Download All Users
                </button>
              </div>
            </div>
            <div>
              {users.map(u => (
                <div
                  key={u.id}
                  style={{ ...styles.listItem, display: 'block', padding: 0, overflow: 'hidden' }}
                  data-hover-list-item
                >
                  <div
                    role="button"
                    tabIndex={0}
                    aria-expanded={expandedUserId === u.id}
                    onClick={() => setExpandedUserId(expandedUserId === u.id ? null : u.id)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        setExpandedUserId(expandedUserId === u.id ? null : u.id);
                      }
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      gap: 12,
                      padding: 16,
                      cursor: 'pointer'
                    }}
                  >
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 16 }}>
                        <span style={{ display: 'inline-block', width: 20, color: '#6b7280' }}>
                          {expandedUserId === u.id ? '▾' : '▸'}
                        </span>
                        {u.full_name} <span style={{ color: '#6b7280', fontWeight: 500 }}>(@{u.username})</span>
                      </div>
                      <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4, marginLeft: 20 }}>
                        {u.email} •
                        <span style={{
                          marginLeft: 6,
                          padding: '2px 8px',
                          borderRadius: 999,
                          fontSize: 11,
                          fontWeight: 600,
                          background: u.is_online ? 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)' : '#f3f4f6',
                          color: u.is_online ? '#065f46' : '#6b7280'
                        }}>
                          {u.is_online ? '● online' : 'offline'}
                        </span>
                        <span style={{
                          marginLeft: 6,
                          padding: '2px 8px',
                          borderRadius: 999,
                          fontSize: 11,
                          fontWeight: 600,
                          background: u.user_type === 'guesser' ? '#dbeafe' : (u.user_type === 'pretender' ? '#fef3c7' : '#f3f4f6'),
                          color: u.user_type === 'guesser' ? '#1e40af' : (u.user_type === 'pretender' ? '#92400e' : '#6b7280')
                        }}>
                          {u.user_type ? (u.user_type === 'guesser' ? '🕵️ Guesser' : '🎭 Pretender') : 'No role'}
                        </span>
                        {u.user_type === 'pretender' && (
                          <span style={{
                            marginLeft: 6,
                            padding: '2px 8px',
                            borderRadius: 999,
                            fontSize: 11,
                            fontWeight: 600,
                            background: u.pretender_identity ? '#ecfdf5' : '#fef2f2',
                            color: u.pretender_identity ? '#065f46' : '#991b1b'
                          }}>
                            {u.pretender_identity === 'human_german' ? '🇩🇪 German'
                              : u.pretender_identity === 'human_non_german' ? '🌍 non-German'
                              : u.pretender_identity === 'ai' ? '🤖 AI'
                              : '⚠️ identity unset'}
                          </span>
                        )}
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ color: '#6b7280', fontSize: 12 }}>
                        {expandedUserId === u.id ? 'Hide details' : 'Show details'}
                      </span>
                      <button
                        onClick={(event) => {
                          event.stopPropagation();
                          exportUser(u.id);
                        }}
                        style={styles.downloadBtn}
                        data-hover-btn
                      >
                        <span style={{ marginRight: 6 }}>📥</span>
                        Download
                      </button>
                      <button
                        onClick={(event) => {
                          event.stopPropagation();
                          deleteUser(u);
                        }}
                        style={styles.dangerBtn}
                        data-hover-btn
                      >
                        <span style={{ marginRight: 6 }}>🗑️</span>
                        Delete
                      </button>
                    </div>
                  </div>

                  {expandedUserId === u.id && (
                    <div style={{
                      borderTop: '1px solid #e5e7eb',
                      background: '#f9fafb',
                      padding: 20
                    }}>
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, minmax(0, 1fr))',
                        gap: 16
                      }}>
                        {[
                          ['Database ID', u.id],
                          ['Full name', u.full_name],
                          ['Nickname', u.username],
                          ['Email', u.email],
                          ['Prolific ID', u.prolific_id],
                          ['Age', u.age],
                          ['Native language', u.native_language],
                          ['Second language', u.language2],
                          ['Third language', u.language3],
                          ['Status', u.is_online ? 'Online' : 'Offline'],
                          ['Consent given', u.consent_given ? 'Yes' : 'No'],
                          ['Consent date', u.consent_given_at ? new Date(u.consent_given_at).toLocaleString() : 'Not provided'],
                          ['Created', u.created_at ? new Date(u.created_at).toLocaleString() : 'Unknown'],
                          ['Completion code', u.completion_code || 'Not assigned']
                        ].map(([label, value]) => (
                          <div key={label} style={{
                            background: 'white',
                            border: '1px solid #e5e7eb',
                            borderRadius: 10,
                            padding: '12px 14px',
                            minWidth: 0
                          }}>
                            <div style={{ color: '#6b7280', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                              {label}
                            </div>
                            <div style={{ color: '#111827', fontSize: 14, fontWeight: 600, marginTop: 5, overflowWrap: 'anywhere' }}>
                              {value ?? 'Not provided'}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div style={{ marginTop: 16 }}>
                        <div style={{ color: '#374151', fontSize: 13, fontWeight: 700, marginBottom: 8 }}>
                          Research role
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                          {[
                            { value: '', label: 'No role' },
                            { value: 'guesser', label: '🕵️ Guesser' },
                            { value: 'pretender', label: '🎭 Pretender' }
                          ].map(opt => {
                            const active = (u.user_type || '') === opt.value;
                            return (
                              <button
                                key={opt.value || 'none'}
                                onClick={(e) => { e.stopPropagation(); setUserType(u.id, opt.value); }}
                                style={{
                                  padding: '8px 16px',
                                  borderRadius: 8,
                                  border: active ? '2px solid #4f46e5' : '1px solid #d1d5db',
                                  background: active ? '#eef2ff' : 'white',
                                  color: active ? '#3730a3' : '#374151',
                                  fontWeight: 600,
                                  fontSize: 13,
                                  cursor: 'pointer'
                                }}
                              >
                                {opt.label}
                              </button>
                            );
                          })}
                        </div>
                        <div style={{ color: '#6b7280', fontSize: 12, marginTop: 6 }}>
                          Guessers can only chat with Pretenders and vice versa.
                        </div>
                      </div>
                      {u.user_type === 'pretender' && (
                        <div style={{ marginTop: 16 }}>
                          <div style={{ color: '#374151', fontSize: 13, fontWeight: 700, marginBottom: 8 }}>
                            Ground-truth identity <span style={{ fontWeight: 500, color: '#6b7280' }}>(claims to be German)</span>
                          </div>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                            {[
                              { value: '', label: 'Unset' },
                              { value: 'human_german', label: '🇩🇪 Human · German' },
                              { value: 'human_non_german', label: '🌍 Human · non-German' },
                              { value: 'ai', label: '🤖 AI' }
                            ].map(opt => {
                              const active = (u.pretender_identity || '') === opt.value;
                              return (
                                <button
                                  key={opt.value || 'unset'}
                                  onClick={(e) => { e.stopPropagation(); setPretenderIdentity(u.id, opt.value); }}
                                  style={{
                                    padding: '8px 16px',
                                    borderRadius: 8,
                                    border: active ? '2px solid #059669' : '1px solid #d1d5db',
                                    background: active ? '#ecfdf5' : 'white',
                                    color: active ? '#065f46' : '#374151',
                                    fontWeight: 600,
                                    fontSize: 13,
                                    cursor: 'pointer'
                                  }}
                                >
                                  {opt.label}
                                </button>
                              );
                            })}
                          </div>
                          <div style={{ color: '#6b7280', fontSize: 12, marginTop: 6 }}>
                            Only "Human · German" makes a "German" guess correct. Used for scoring.
                          </div>
                        </div>
                      )}
                      <div style={{ marginTop: 16 }}>
                        <div style={{ color: '#374151', fontSize: 13, fontWeight: 700, marginBottom: 8 }}>
                          Personality scores
                        </div>
                        <pre style={{
                          margin: 0,
                          padding: 14,
                          background: 'white',
                          border: '1px solid #e5e7eb',
                          borderRadius: 10,
                          color: '#374151',
                          fontSize: 12,
                          whiteSpace: 'pre-wrap',
                          overflowWrap: 'anywhere'
                        }}>
                          {u.personality_scores
                            ? JSON.stringify(u.personality_scores, null, 2)
                            : 'No personality scores recorded.'}
                        </pre>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Removed legacy 'rooms' tab */}

        {tab === 'rooms_messages' && (
          <div>
            <div style={styles.sectionHeader}>
              <div style={styles.sectionTitle}>
                <span style={styles.sectionIcon}>💬</span>
                <h3 style={styles.sectionHeading}>Rooms: Messages</h3>
              </div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <button onClick={deleteAllRooms} style={styles.dangerBtn} data-hover-btn>
                  <span style={{ marginRight: 6 }}>🗑️</span>
                  Delete All Chats
                </button>
                <button onClick={exportAllRooms} style={styles.downloadBtn}>
                  <span style={{ marginRight: 6 }}>📥</span>
                  Download All Rooms
                </button>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1.6fr', gap: isMobile ? 20 : 36 }} data-rooms-grid>
              <div>
                {rooms.length === 0 && (
                  <div style={{ marginBottom: 12, color: '#6b7280' }}>No rooms found.</div>
                )}
                {rooms.map(r => (
                  <div key={r.id} style={{ ...styles.listItem, ...(r.id === selectedRoomId ? styles.roomListItemSelected : {}) }} data-hover-list-item>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600, fontSize: 16, color: '#111827' }}>
                        <span style={{
                          display: 'inline-block',
                          padding: '4px 12px',
                          borderRadius: 8,
                          background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                          color: 'white',
                          fontWeight: 700,
                          fontSize: 15
                        }}>Chat Room #{r.id}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 6 }}>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', flex: 1, minWidth: 0 }}>
                          {r.assigned_task && (
                            <span style={{ 
                              fontSize: 12, 
                              padding: '2px 8px', 
                              borderRadius: 999, 
                              background: r.assigned_task.active ? '#e0f2fe' : '#fee2e2', 
                              color: r.assigned_task.active ? '#0369a1' : '#991b1b', 
                              border: r.assigned_task.active ? '1px solid #bae6fd' : '1px solid #fecaca'
                            }}>
                              Task: {r.assigned_task.title} {!r.assigned_task.active && '(deactivated)'}
                            </span>
                          )}
                          {r.pretender_identity && (
                            <span style={{ fontSize: 12, padding: '2px 8px', borderRadius: 999, background: '#eef2ff', color: '#3730a3', border: '1px solid #c7d2fe' }}>
                              Truth: {r.pretender_identity === 'human_german' ? '🇩🇪 German' : r.pretender_identity === 'human_non_german' ? '🌍 non-German' : '🤖 AI'}
                            </span>
                          )}
                          {r.guesser_guess && (
                            <span style={{
                              fontSize: 12, padding: '2px 8px', borderRadius: 999,
                              background: r.guess_correct == null ? '#f1f5f9' : (r.guess_correct ? '#dcfce7' : '#fee2e2'),
                              color: r.guess_correct == null ? '#334155' : (r.guess_correct ? '#166534' : '#991b1b'),
                              border: `1px solid ${r.guess_correct == null ? '#e2e8f0' : (r.guess_correct ? '#bbf7d0' : '#fecaca')}`
                            }}>
                              Guess: {r.guesser_guess === 'german' ? 'German' : 'not German'} {r.guess_correct == null ? '• unscored' : (r.guess_correct ? '✓ correct' : '✗ wrong')}
                            </span>
                          )}
                          {(r.guesser_questions != null) && (
                            <span style={{ fontSize: 12, padding: '2px 8px', borderRadius: 999, background: '#f1f5f9', color: '#334155', border: '1px solid #e2e8f0' }}>
                              ❓ {r.guesser_questions} question{r.guesser_questions === 1 ? '' : 's'}
                            </span>
                          )}
                          {(r.guesser_points != null || r.pretender_points != null) && (
                            <span style={{ fontSize: 12, padding: '2px 8px', borderRadius: 999, background: '#f5f3ff', color: '#5b21b6', border: '1px solid #ddd6fe' }}>
                              🕵️ {r.guesser_points ?? 0} · 🎭 {r.pretender_points ?? 0}
                            </span>
                          )}
                          {(r.guesser_confidence != null) && (
                            <span style={{ fontSize: 12, padding: '2px 8px', borderRadius: 999, background: '#eef2ff', color: '#3730a3', border: '1px solid #c7d2fe' }}>
                              🎯 confidence {r.guesser_confidence}/5
                            </span>
                          )}
                          {r.guesser_ai_suspicion && (
                            <span style={{ fontSize: 12, padding: '2px 8px', borderRadius: 999, background: '#f0f9ff', color: '#075985', border: '1px solid #7dd3fc' }}>
                              {r.guesser_ai_suspicion === 'ai' ? '🤖 thought AI' : '🧑 thought human'}
                            </span>
                          )}
                          {r.guesser_reason && (() => {
                            const expanded = expandedReasonRoomId === r.id;
                            return (
                              <span
                                onClick={() => setExpandedReasonRoomId(expanded ? null : r.id)}
                                title={expanded ? 'Click to collapse' : 'Click to expand'}
                                style={{
                                  fontSize: 12, padding: '2px 8px', borderRadius: expanded ? 8 : 999,
                                  background: '#fffbeb', color: '#92400e', border: '1px solid #fde68a',
                                  cursor: 'pointer',
                                  ...(expanded
                                    ? { whiteSpace: 'pre-wrap', maxWidth: '100%', flexBasis: '100%' }
                                    : { maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }),
                                }}>
                                💬 “{r.guesser_reason}” {expanded ? '▲' : '▾'}
                              </span>
                            );
                          })()}
                        </div>
                        <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                          <button onClick={() => loadMessages(r.id)} style={{ ...styles.primaryBtn, ...styles.roomBtn }} data-hover-btn>
                            <span style={{ display: 'block' }}>View</span>
                            <span style={{ display: 'block' }}>Messages</span>
                          </button>
                          <button onClick={() => downloadRoomMessages(r.id)} style={{ ...styles.downloadBtn, ...styles.roomBtn }} data-hover-btn>
                            <span style={{ display: 'block' }}>Download</span>
                            <span style={{ display: 'block' }}>Messages</span>
                          </button>
                          <button onClick={() => deleteRoom(r.id)} style={{ ...styles.dangerBtn, ...styles.roomBtn }} data-hover-btn>
                            <span style={{ display: 'block' }}>🗑️</span>
                            <span style={{ display: 'block' }}>Delete</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div>
                <h4 style={{ marginTop: 8, marginBottom: 12 }}>
                  {selectedRoomId ? (
                    <span style={{
                      display: 'inline-block',
                      padding: '8px 20px',
                      borderRadius: 12,
                      background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)',
                      color: 'white',
                      fontWeight: 700,
                      fontSize: 18,
                      boxShadow: '0 4px 14px rgba(99, 102, 241, 0.4)',
                      letterSpacing: '0.5px'
                    }}>
                      Chat Room #{selectedRoomId}
                    </span>
                  ) : 'Messages'}
                </h4>
                <div style={{ maxHeight: 520, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 12, padding: 20, background: '#f8fafc' }}>
              {!selectedRoomId && (
                <div style={{ color: '#6b7280' }}>Select a room above to view its messages.</div>
              )}
              {(() => {
                const room = rooms.find(r => r.id === selectedRoomId);
                // user_a = first message sender (chronologically), user_b = the other
                let leftId = null;
                let rightId = null;
                const sortedMsgs = [...roomMessages].sort((a, b) => new Date(a.created_at || 0) - new Date(b.created_at || 0));
                if (sortedMsgs.length > 0) {
                  const firstSenderId = (sortedMsgs[0].sender && sortedMsgs[0].sender.id) || sortedMsgs[0].sender_id;
                  const uniq = [];
                  sortedMsgs.forEach(mm => {
                    const sid = (mm.sender && mm.sender.id) || mm.sender_id;
                    if (sid != null && !uniq.includes(sid)) uniq.push(sid);
                  });
                  leftId = firstSenderId;
                  rightId = uniq.find(sid => sid !== firstSenderId) || uniq[1];
                }
                const memId = (m) => m?.id ?? m?.user_id;
                if (!leftId && room?.members?.[0]) leftId = memId(room.members[0]);
                if (!rightId && room?.members?.[1]) rightId = memId(room.members[1]);
                const getDisplayLabel = (senderId) => {
                  if (senderId != null && senderId === leftId) return 'User A';
                  if (senderId != null && senderId === rightId) return 'User B';
                  return 'Unknown';
                };
                return (
                  <>
                    {roomMessages.map(m => {
                      const senderId = (m.sender && m.sender.id) || m.sender_id;
                      const isLeft = leftId && senderId === leftId;
                      const displayLabel = m.sender_label ? `User ${String(m.sender_label).replace('user_', '').toUpperCase()}` : getDisplayLabel(senderId);
                      const bubbleStyle = isLeft
                        ? { background: '#eef2ff', color: '#111827', border: '1px solid #c7d2fe' }
                        : { background: '#e8f5e9', color: '#111827', border: '1px solid #c8e6c9' };
                      const chipBg = isLeft ? '#e0e7ff' : '#def7ec';
                      const chipColor = isLeft ? '#3730a3' : '#065f46';
                      return (
                        <div key={m.id} style={{ display: 'flex', justifyContent: isLeft ? 'flex-start' : 'flex-end', marginBottom: 8 }}>
                          <div style={{ maxWidth: '70%', minWidth: '35%', ...bubbleStyle, borderRadius: 12, padding: 10, boxShadow: '0 4px 10px rgba(0,0,0,0.04)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                              <div style={{ ...styles.avatar, width: 20, height: 20, fontSize: 12, background: chipBg, color: chipColor }}>{displayLabel.replace('User ', '').charAt(0)}</div>
                              <div style={{ fontWeight: 700, opacity: 0.95, fontSize: 12 }}>{displayLabel}</div>
                            </div>
                            <div style={{ fontSize: 12, opacity: 0.95 }}>
                              {m.original_content || m.content}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                );
              })()}
              {roomMessages.length === 0 && (
                <div style={{ color: '#6b7280' }}>No messages loaded. Select a room above.</div>
              )}
                </div>
              </div>
            </div>
          </div>
        )}

        {tab === 'settings' && (
          <div>
            <div style={styles.sectionHeader}>
              <div style={styles.sectionTitle}>
                <span style={styles.sectionIcon}>⚙️</span>
                <h3 style={styles.sectionHeading}>Application Text & Appearance</h3>
              </div>
            </div>

            {/* Role Instructions */}
            <div style={{ marginBottom: 32 }}>
              <h4 data-settings-title style={{ fontSize: 18, fontWeight: 700, color: '#111827', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 20 }}>🎭</span>
                Role Instructions
              </h4>
              <p data-settings-desc style={{ fontSize: 14, color: '#6b7280', marginBottom: 16 }}>
                Shown to each participant based on their assigned role. Guessers and Pretenders each see their own text before and during a chat.
              </p>
              {[
                { key: 'instructions.guesser', label: '🕵️ Guesser instructions' },
                { key: 'instructions.pretender', label: '🎭 Pretender instructions' }
              ].map(({ key, label }) => (
                <div key={key} data-settings-card style={{
                  background: 'white',
                  border: '2px solid #e5e7eb',
                  borderRadius: 14,
                  padding: 20,
                  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
                  marginBottom: 16
                }}>
                  <label style={{ ...styles.settingsLabel, display: 'block', marginBottom: 8 }}>{label}</label>
                  <textarea
                    value={settingsDraft[key] || ''}
                    onChange={e => setSettingsDraft({ ...settingsDraft, [key]: e.target.value })}
                    rows={4}
                    style={{ ...styles.input, width: '100%', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5 }}
                  />
                  <div style={{ marginTop: 10 }}>
                    <button
                      onClick={async () => {
                        try { await saveOneSetting(key); alert('✅ Instructions saved.'); }
                        catch (err) { alert(`Failed to save: ${err.response?.data?.detail || err.message}`); }
                      }}
                      style={{ ...styles.successBtn, padding: '10px 20px' }}
                      data-hover-btn
                    >
                      Save
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ marginBottom: 32 }}>
              <h4 data-settings-title style={{ fontSize: 18, fontWeight: 700, color: '#111827', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 20 }}>🔑</span>
                Prolific Completion Code
              </h4>
              <p data-settings-desc style={{ fontSize: 14, color: '#6b7280', marginBottom: 16 }}>
                This same code is shown to every user after they finish a conversation.
              </p>
              <div data-settings-card style={{
                background: 'linear-gradient(135deg, #eef2ff 0%, #ecfdf5 100%)',
                border: '2px solid #a5b4fc',
                borderRadius: 14,
                padding: 20,
                boxShadow: '0 6px 20px rgba(79, 70, 229, 0.10)'
              }}>
                <label style={{ ...styles.settingsLabel, display: 'block', marginBottom: 8 }}>
                  Prolific code
                </label>
                <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 12 }}>
                  <input
                    type="text"
                    value={settingsDraft['study.completion_code'] || ''}
                    onChange={e => setSettingsDraft({ ...settingsDraft, 'study.completion_code': e.target.value })}
                    placeholder="C1EDIWV1"
                    autoComplete="off"
                    style={{
                      ...styles.input,
                      flex: 1,
                      background: '#ffffff',
                      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                      fontSize: 18,
                      fontWeight: 700,
                      letterSpacing: '0.08em'
                    }}
                  />
                  <button onClick={saveCompletionCode} style={{ ...styles.successBtn, padding: '12px 22px' }} data-hover-btn>
                    Save Code
                  </button>
                </div>
              </div>
            </div>
            
            {/* Feature Mode — locked to "none" for the Cultural Turing Test */}
            <div style={{ marginBottom: 32 }}>
              <h4 data-settings-title style={{ fontSize: 18, fontWeight: 700, color: '#111827', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 20 }}>🎯</span>
                Conversation Mode
              </h4>
              <div data-settings-card style={{
                background: '#f9fafb',
                border: '1px solid #e5e7eb',
                borderRadius: 14,
                padding: 20
              }}>
                <div style={{ fontSize: 14, color: '#374151', lineHeight: 1.6 }}>
                  This deployment runs the <strong>Cultural Turing Test</strong>. The legacy
                  Topics/Tasks assignment is disabled — chats are free conversation between a
                  Guesser and a Pretender. Configure the experience under
                  <strong> Role Instructions</strong> above, and assign roles and Pretender
                  identities on the <strong>Users</strong> tab.
                </div>
              </div>
            </div>

            {/* Waiting screen & matchmaking */}
            <div style={{ marginBottom: 32 }}>
              <h4 data-settings-title style={{ fontSize: 18, fontWeight: 700, color: '#111827', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 20 }}>⏳</span>
                Waiting Screen & Matchmaking
              </h4>
              <p data-settings-desc style={{ fontSize: 14, color: '#6b7280', marginBottom: 16 }}>
                Shown while a participant waits to be auto-matched with a partner of the complementary role.
                The timeout text appears if no partner is found within the time limit.
              </p>
              {[
                { key: 'match.wait.title', label: 'Waiting title', type: 'text', placeholder: "Looking for a partner…" },
                { key: 'match.wait.text', label: 'Waiting message', type: 'textarea', placeholder: "We'll connect you automatically as soon as a partner is available." },
                { key: 'match.timeout.seconds', label: 'Timeout (seconds before giving up)', type: 'number', placeholder: "300" },
                { key: 'match.timeout.title', label: 'Timeout title', type: 'text', placeholder: "No partner found" },
                { key: 'match.timeout.text', label: 'Timeout message', type: 'textarea', placeholder: "We couldn't find a partner right now. Please use the completion code below." }
              ].map(({ key, label, type, placeholder }) => (
                <div key={key} data-settings-card style={{
                  background: 'white',
                  border: '2px solid #e5e7eb',
                  borderRadius: 14,
                  padding: 20,
                  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
                  marginBottom: 16
                }}>
                  <label style={{ ...styles.settingsLabel, display: 'block', marginBottom: 8 }}>{label}</label>
                  {type === 'textarea' ? (
                    <textarea
                      value={settingsDraft[key] || ''}
                      onChange={e => setSettingsDraft({ ...settingsDraft, [key]: e.target.value })}
                      rows={3}
                      placeholder={placeholder}
                      style={{ ...styles.input, width: '100%', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5 }}
                    />
                  ) : (
                    <input
                      type={type}
                      value={settingsDraft[key] || ''}
                      onChange={e => setSettingsDraft({ ...settingsDraft, [key]: e.target.value })}
                      placeholder={placeholder}
                      style={{ ...styles.input, width: '100%' }}
                    />
                  )}
                  <div style={{ marginTop: 10 }}>
                    <button
                      onClick={async () => {
                        try { await saveOneSetting(key); alert('✅ Saved.'); }
                        catch (err) { alert(`Failed to save: ${err.response?.data?.detail || err.message}`); }
                      }}
                      style={{ ...styles.successBtn, padding: '10px 20px' }}
                      data-hover-btn
                    >
                      Save
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* User Card Visibility Settings */}
            <div style={{ marginBottom: 32 }}>
              <h4 data-settings-title style={{ fontSize: 18, fontWeight: 700, color: '#111827', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 20 }}>👤</span>
                User Card Visibility Settings
              </h4>
              <p data-settings-desc style={{ fontSize: 14, color: '#6b7280', marginBottom: 16 }}>
                Control which information is displayed on user cards. Unchecked fields will be hidden from all users.
              </p>
              <div data-settings-card style={{ 
                background: 'white', 
                border: '2px solid #e5e7eb', 
                borderRadius: 14, 
                padding: 20,
                boxShadow: '0 6px 20px rgba(0,0,0,0.08)'
              }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  {[
                    { key: 'usercard.show_name', label: 'Show Full Name', icon: '👤' },
                    { key: 'usercard.show_age', label: 'Show Age', icon: '🎂' },
                    { key: 'usercard.show_language', label: 'Show Language', icon: '🌍' }
                  ].map(field => (
                    <div key={field.key} data-settings-option style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'space-between',
                      padding: 16,
                      background: '#f9fafb',
                      borderRadius: 10,
                      border: '1px solid #e5e7eb'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <span style={{ fontSize: 24 }}>{field.icon}</span>
                        <span style={{ fontSize: 15, fontWeight: 600, color: '#111827' }}>{field.label}</span>
                      </div>
                      <div data-settings-option-actions style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                          <input
                            type="checkbox"
                            checked={String(settingsDraft[field.key] || 'true').toLowerCase() === 'true'}
                            onChange={(e) => {
                              const newValue = e.target.checked ? 'true' : 'false';
                              setSettingsDraft({ ...settingsDraft, [field.key]: newValue });
                            }}
                            style={{ 
                              width: 20, 
                              height: 20, 
                              cursor: 'pointer',
                              accentColor: '#10b981'
                            }}
                          />
                          <span style={{ 
                            marginLeft: 8, 
                            fontSize: 13, 
                            fontWeight: 600,
                            color: String(settingsDraft[field.key] || 'true').toLowerCase() === 'true' ? '#10b981' : '#6b7280'
                          }}>
                            {String(settingsDraft[field.key] || 'true').toLowerCase() === 'true' ? 'Visible' : 'Hidden'}
                          </span>
                        </label>
                        <button 
                          onClick={() => saveOneSetting(field.key)} 
                          style={{ ...styles.successBtn, padding: '6px 14px', fontSize: 13 }} 
                          data-hover-btn
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                <button 
                  onClick={async () => {
                    const userCardSettings = {
                      'usercard.show_name': settingsDraft['usercard.show_name'] || 'true',
                      'usercard.show_age': settingsDraft['usercard.show_age'] || 'true',
                      'usercard.show_language': settingsDraft['usercard.show_language'] || 'true'
                    };
                    await axios.post(`${API_BASE_URL}/admin/settings`, { settings: userCardSettings }, { headers: getAuthHeader() });
                    await loadSettings();
                    alert('✅ All user card visibility settings saved!');
                  }}
                  style={{ 
                    ...styles.primaryBtn, 
                    width: '100%', 
                    marginTop: 16,
                    padding: '12px'
                  }} 
                  data-hover-btn
                >
                  💾 Save All User Card Settings
                </button>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16 }} data-settings-grid>
              {[
                { key: 'app.title', label: 'Browser Tab Title' },
                { key: 'home.title', label: 'Home Title' },
                { key: 'home.subtitle', label: 'Home Subtitle' },
                { key: 'consent.title', label: 'Consent Title' },
                { key: 'consent.subtitle', label: 'Consent Subtitle' },
                { key: 'consent.body', label: 'Consent Body (use new lines)' },
                { key: 'consent.checkbox', label: 'Consent Checkbox Label' },
              ].map(field => (
                <div key={field.key} style={styles.settingsCard} data-hover-card>
                  <div style={styles.settingsLabel}>{field.label}</div>
                  {field.key.includes('body') || field.key.includes('text') ? (
                    <textarea
                      value={settingsDraft[field.key] || ''}
                      onChange={e => setSettingsDraft({ ...settingsDraft, [field.key]: e.target.value })}
                      style={{ ...styles.input, minHeight: 140, background: '#ffffff' }}
                    />
                  ) : (
                    <input
                      value={settingsDraft[field.key] || ''}
                      onChange={e => setSettingsDraft({ ...settingsDraft, [field.key]: e.target.value })}
                      style={{ ...styles.input, background: '#ffffff' }}
                    />
                  )}
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button onClick={() => saveOneSetting(field.key)} style={{ ...styles.successBtn, marginTop: 10 }} data-hover-btn>Save</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: { 
    minHeight: '100vh', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    background: 'linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%)', 
    padding: 20 
  },
  page: { 
    minHeight: '100vh', 
    background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 50%, #bbf7d0 100%)',
    overflow: 'auto'
  },
  card: {
    background: 'white',
    padding: 20,
    borderRadius: 16,
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    minWidth: 'auto',
    width: '100%',
    border: '1px solid #e5e7eb'
  },
  statGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: 16,
  },
  statCard: {
    padding: 20,
    borderRadius: 16,
    background: 'white',
    border: '2px solid #e5e7eb',
    boxShadow: '0 4px 14px rgba(0,0,0,0.05)',
  },
  loginCard: { 
    background: 'white', 
    padding: 32, 
    borderRadius: 20, 
    boxShadow: '0 25px 50px rgba(16, 185, 129, 0.15)', 
    minWidth: 'auto', 
    width: '95%',
    maxWidth: 420,
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(135deg, #10b981 0%, #059669 100%)',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box'
  },
  loginTitle: { 
    margin: 0, 
    fontSize: 28, 
    fontWeight: 700, 
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    color: 'transparent'
  },
  loginSubtitle: { margin: 0, marginTop: 8, fontSize: 14, color: '#6b7280' },
  loginInput: { 
    padding: 14, 
    border: '2px solid #e5e7eb', 
    borderRadius: 12, 
    fontSize: 14,
    transition: 'all 0.3s ease',
    outline: 'none'
  },
  loginButton: { 
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', 
    color: 'white', 
    border: 'none', 
    padding: '12px 16px', 
    borderRadius: 12, 
    cursor: 'pointer', 
    fontWeight: 600, 
    marginTop: 8,
    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
    transition: 'all 0.3s ease'
  },
  input: { 
    padding: 12, 
    border: '2px solid #e5e7eb', 
    borderRadius: 10, 
    fontSize: 14,
    transition: 'border 0.2s ease'
  },
  primaryBtn: { 
    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', 
    color: 'white', 
    border: 'none', 
    padding: '10px 16px', 
    borderRadius: 10, 
    cursor: 'pointer',
    fontWeight: 600,
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
    transition: 'all 0.3s ease'
  },
  roomBtn: { minWidth: 120, textAlign: 'center', padding: '8px 12px', fontSize: 12, lineHeight: 1.1 },
  successBtn: { 
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', 
    color: 'white', 
    border: 'none', 
    padding: '8px 12px', 
    borderRadius: 10, 
    cursor: 'pointer',
    fontWeight: 600,
    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.25)',
    transition: 'all 0.3s ease'
  },
  dangerBtn: { 
    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', 
    color: 'white', 
    border: 'none', 
    padding: '8px 14px', 
    borderRadius: 10, 
    cursor: 'pointer',
    fontWeight: 600,
    boxShadow: '0 4px 12px rgba(239, 68, 68, 0.25)',
    transition: 'all 0.3s ease'
  },
  logoutBtn: { 
    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', 
    color: 'white', 
    border: 'none', 
    padding: '10px 16px', 
    borderRadius: 12, 
    cursor: 'pointer',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 4px 12px rgba(239, 68, 68, 0.25)',
    transition: 'all 0.3s ease'
  },
  topbar: { 
    background: 'white', 
    borderBottom: '2px solid #e5e7eb', 
    padding: '16px 24px', 
    display: 'flex', 
    alignItems: 'center',
    flexWrap: 'wrap', 
    justifyContent: 'space-between',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  topbarBrand: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },
  brandIcon: {
    width: 40,
    height: 40,
    borderRadius: 10,
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20,
    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)'
  },
  brandText: {
    fontWeight: 700,
    fontSize: 20,
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    color: 'transparent'
  },
  tabsContainer: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    flexWrap: 'wrap',
    flex: 1
  },
  tabBtn: { 
    background: '#f9fafb', 
    border: '2px solid #e5e7eb', 
    padding: '10px 16px', 
    borderRadius: 12, 
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    color: '#6b7280',
    boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
  },
  tabIcon: {
    fontSize: 16,
    display: 'inline-flex',
    alignItems: 'center'
  },
  tabActive: { 
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', 
    color: 'white', 
    borderColor: '#10b981',
    boxShadow: '0 6px 16px rgba(16, 185, 129, 0.35)',
    transform: 'translateY(-2px)'
  },
  downloadBtn: { 
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', 
    color: 'white', 
    border: 'none', 
    padding: '10px 16px', 
    borderRadius: 10, 
    cursor: 'pointer',
    fontWeight: 600,
    boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
    transition: 'all 0.3s ease'
  },
  content: { 
    padding: 32, 
    maxWidth: 1600, 
    margin: '0 auto' 
  },
  listItem: { 
    display: 'flex', 
    alignItems: 'flex-start', 
    justifyContent: 'space-between', 
    flexWrap: 'wrap',
    gap: 12,
    background: 'white', 
    border: '2px solid #e5e7eb', 
    borderRadius: 12, 
    padding: 16, 
    marginBottom: 12,
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    transition: 'all 0.3s ease'
  },
  roomListItemSelected: {
    background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)',
    border: '2px solid #6366f1',
    boxShadow: '0 4px 16px rgba(99, 102, 241, 0.25)'
  },
  row: { display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12 },
  memberChip: { 
    background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)', 
    color: '#1e40af', 
    padding: '6px 12px', 
    borderRadius: 999, 
    fontSize: 12, 
    border: '1px solid #93c5fd',
    fontWeight: 600
  },
  messageCard: { 
    background: 'white', 
    border: '2px solid #e5e7eb', 
    borderRadius: 16, 
    padding: 16, 
    marginBottom: 16, 
    boxShadow: '0 8px 20px rgba(0,0,0,0.06)',
    transition: 'all 0.3s ease'
  },
  messageHeader: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 },
  avatar: { 
    width: 36, 
    height: 36, 
    borderRadius: '50%', 
    background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)', 
    color: '#1e40af', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    fontWeight: 700,
    border: '2px solid #93c5fd'
  },
  messageTitle: { fontWeight: 600 },
  messageMeta: { fontSize: 12, color: '#6b7280' },
  messageBody: { fontSize: 14, lineHeight: 1.6 }
};

// Settings cards styling
styles.settingsCard = {
  background: 'white',
  border: '2px solid #e5e7eb',
  borderRadius: 14,
  padding: 16,
  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  transition: 'all 0.3s ease'
};
styles.settingsLabel = { fontSize: 13, color: '#6b7280', fontWeight: 600 };

// Section header styling
styles.sectionHeader = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 24,
  paddingBottom: 16,
  borderBottom: '2px solid #e5e7eb'
};
styles.sectionTitle = {
  display: 'flex',
  alignItems: 'center',
  gap: 12
};
styles.sectionIcon = {
  fontSize: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 48,
  height: 48,
  borderRadius: 12,
  background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
  boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)'
};
styles.sectionHeading = {
  margin: 0,
  fontSize: 24,
  fontWeight: 700,
  color: '#111827'
};

export default AdminPanel;


